export default __webpack_public_path__ + "static/media/csulb_image2.5fc3460d.jpg";